<!-- eslint-disable vue/multi-word-component-names -->
<!--
*  TTTech nerve-ui-components
*  Copyright(c) 2021. TTTech Industrial Automation AG.
*
*  ALL RIGHTS RESERVED.
*
*  Usage of this software, including source code, netlists, documentation,
*  is subject to restrictions and conditions of the applicable license
*  agreement with TTTech Industrial Automation AG or its affiliates.
*
*  All trademarks used are the property of their respective owners.
*
*  TTTech Industrial Automation AG and its affiliates do not assume any liability
*  arising out of the application or use of any product described or shown
*  herein. TTTech Industrial Automation AG and its affiliates reserve the right to
*  make changes, at any time, in order to improve reliability, function or
*  design.
*
*  Contact Information:
*  support@tttech-industrial.com
*
*  TTTech Industrial Automation AG, Schoenbrunnerstrasse 7, 1040 Vienna, Austria
*
* -->
<template>
  <v-row id="iiotLogin">
    <v-col lg="3" md="5" sm="12">
      <slot name="login-actions" />
    </v-col>
    <v-col class="background">
      <background :logo="logo" :image="image" />
    </v-col>
  </v-row>
</template>

<script>
import Background from './helpers/Background.vue';

export default {
  components: {
    Background,
  },
  props: {
    logo: {
      type: String,
      default: '',
    },
    image: {
      type: String,
      default: '',
    },
  },
};
</script>
<style scoped>
#iiotLogin {
  height: 100vh;
  margin: 0;
  flex-wrap: initial;
}
.background {
  width: 100%;
  padding-top: 0px;
  padding-bottom: 0px;
  padding-right: 0px;
}
</style>
